import React from "react";

import { Select, Space , Button , Modal, notification, Upload, Table as TableAntd, Alert} from "antd";
import {ReloadOutlined, UploadOutlined} from "@ant-design/icons"
import {CountryVatItem} from '../CountryVatItem'
import {
    visualizeCountryVatRates,
    visualizeCountryAlpha2,
    uploadFile,
    syncVATRates,
} from "../../api/api";
import TableDataSource from "../../utils/TableDataSource";
import { InboxOutlined } from '@ant-design/icons';
import {DefaultProps, RefTable} from "../RefTable";
import {unstable_batchedUpdates} from "react-dom";
import {TableContext} from "@q4us-sw/q4us-ui/lib/TableV2";

const { Option } = Select;
const { Dragger } = Upload;

const ViewItem = (props) => {

    const [opt, setOpt] = React.useState({country : undefined, country_name : undefined, rate_type: undefined, country_vat_rate_id : undefined, openItem: false});

    return <React.Fragment>
        <Modal
            key = {opt.openItem}
            centered
            width="80vw"
            closable={true}
            onCancel={() => {
                setOpt({country : undefined, country_name : undefined, country_vat_rate_id : undefined, openItem: false });
            }}
            footer={null}
            title={`HS6+ Codes for ${opt.rate_type} VAT type for ${opt.country_name}`}
            visible={opt.openItem}
        >
            <CountryVatItem
                country_vat_rate_id = {opt.country_vat_rate_id}
                country = {opt.country}
            />
        </Modal>
        <Button Button onClick={()=>{
            setOpt({country: props.value,
                country_name : props.formatted,
                rate_type: props.row['rate_type'],
                country_vat_rate_id: props.row['id'],
                openItem : true})
        }}>Items</Button>

    </React.Fragment>
};

const CountrySelect = (props) => {
    const [country, setCountry] = React.useState({});
    const countries = []
    const load = async ()=>{
        const { data } = await visualizeCountryAlpha2() || {};
        const {countrycodes} = data
        for (let key in countrycodes) {
            countries.push(countrycodes[key])
        }
        setCountry(countries);
    }

    React.useEffect(()=>{
        load();
    },[])

    return <React.Fragment>
        <Select showSearch
                style={{ width: 160 }}
                placeholder="Select a country"
                optionFilterProp="children"
                onChange={(e)=>{props.onChangeCountry(e)}}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
        >
            <Option value="ALL">All Countries</Option>
            {Object.values(country).map((country, index) => {
                return <Option key={index} value={country.iso_alpha_2}>{country.name}</Option>;
            })}
        </Select>
    </React.Fragment>
};

const CustomUpload = ()=> {

    const [openWindow, setOpenWindow] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const [showTable, setShowTable] = React.useState(false);
    const [alert, setAlerts] = React.useState({success: false, error: false, uploading: false, rowCount:0, uploadedRowCount:0});
    const [source, setSource] = React.useState(new TableDataSource());

    const columns = [
        {
            title: 'Row Index',
            dataIndex: 'rowId',
            key: 'rowId',
        },
        {
            title: 'Error / Warning',
            dataIndex: 'error',
            key: 'error',
        },
        {
            title: 'Field',
            dataIndex: 'columnName',
            key: 'columnName',
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
        },
    ];


    async function customUpload(data) {

        setAlerts({
            success: false, error: false, uploading: true, rowCount:0, uploadedRowCount:0
        });
        setShowTable(false);
        const formData = new FormData();
        formData.append('data_type', 'country_vat_rate');
        formData.append('file',data.file);
        const response = await uploadFile(formData);
        const errorMessage = 'File upload failed';

        if (response) {
            const { statusText } = response;
            const data = response.data[0];
            const {errorList, status, noOfRowsUploaded, noOfRows, excludeRowCount, errorMsg} = data;
            setShowTable(false);
            setSource(new TableDataSource());
            //setRefresh(refresh+1);

            setAlerts({
                success: true, error: false, uploading: false, rowCount:noOfRows, uploadedRowCount:noOfRowsUploaded, excludeRowCount: excludeRowCount
            });

            if (status === 'success') {
                if (errorList && errorList.length > 0) {
                    setShowTable(true);
                    const results= errorList.map(row => ({
                        key: row.id,
                        rowId: row.row,
                        columnName: row.column,
                        value: row.value,
                        error: row.error
                    }));
                    setErrors(results);
                } else {
                    setShowTable(false);
                }

            } else {
                setAlerts({
                    success: false, error: true, uploading: false, rowCount:0, uploadedRowCount:0, errorMsg: errorMsg
                });
                setShowTable(false);
            }
        } else {
            setAlerts({
                success: false, error: true, uploading: false, rowCount:0, uploadedRowCount:0, errorMsg: errorMessage
            });
        }
    }

    return <React.Fragment>
        <Modal
            centered
            closable={true}
            onCancel={() => {
                setOpenWindow(false);
                setErrors([]);
                setAlerts({success: false, error: false, uploading: false, rowCount:0, uploadedRowCount:0});
                setShowTable(false);
            }}
            footer={null}
            title={`VAT Rates File Upload`}
            visible={openWindow}
        >
            <div>
                <Dragger customRequest={customUpload} accept={".xlsx"} multiple={false} showUploadList={false}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Support for a single excel file upload.
                    </p>
                </Dragger>
            </div>
            <div style={{marginBlock: '15px'}}>
                {alert.uploading && <Alert
                    message="File uploading ....."
                    type="info"
                    showIcon
                />}
                {alert.success && <Alert
                    message="File uploaded successfully"
                    description= {`${alert.uploadedRowCount} row(s) out of  ${alert.rowCount} row(s) uploaded and ${alert.excludeRowCount} row(s) skipped with CPA code`}
                    type="success"
                    showIcon
                />}
                {alert.error && <Alert
                    message={`${alert.errorMsg}`}
                    type="error"
                    showIcon
                />}
            </div>
            <div style={{marginBlock: '15px'}}>
                {showTable && <TableAntd columns={columns} dataSource={errors} size={'middle'}>
                </TableAntd>}
            </div>
        </Modal>
        <Button style={{ width: 160 }} icon={<UploadOutlined />} onClick={() => setOpenWindow(true)}>Upload File</Button>
    </React.Fragment>
};

const Sync = ()=> {
    const [openSyncAlertWindow, setOpenSyncAlertWindow] = React.useState(false);

    return <React.Fragment>
        <Modal
            centered
            closable={true}
            onCancel={()=>{setOpenSyncAlertWindow(false)}}
            footer={null}
            title={`Sync VAT Rates`}
            visible={openSyncAlertWindow}
        >
            <p>This operation will delete all available VAT rates except for system reserved and synchronize with latest published rates of European Commission.</p>
            <p>Are you sure?</p>
            <Space>
                <Button onClick={async ()=>{
                    notification.info({message: `VAT rate synchronizing request sent`})
                    setOpenSyncAlertWindow(false)
                    try{
                        const {status, data} = await syncVATRates()
                        if(status === 200){
                            notification.success({message: `VAT rates successfully synchronized`})
                        }
                        else{
                            throw('Service unavailable')
                        }
                    }
                    catch(e){
                        notification.error({message: `Error with synchronizing VAT rates: ${e}`})
                    }
                }} type="primary">Yes</Button>
                <Button onClick={()=>{setOpenSyncAlertWindow(false)}}>Cancel</Button>
            </Space>

        </Modal>
        <Button style={{ width: 160 }} icon={<ReloadOutlined />} onClick={() => setOpenSyncAlertWindow(true)}>Sync</Button>
    </React.Fragment>
};



export const CountryVatRates  = (props)=> <RefTable {...props}/>;

CountryVatRates.defaultProps = {
    ...DefaultProps,
    title: "VAT Rates",
    tableSchema: "country_vat_rate",
    tableName: "country_vat_rate",
    edit: true,
    theadHeight: 62,
    headerOrder:["customActionElements", "add"],
    customActionElements:[
        <TableContext.Consumer>
            {table=><CountrySelect
                onChangeCountry={async (country)=> {
                    table?.setLoading(true)
                    const res = await visualizeCountryVatRates(country);
                    unstable_batchedUpdates(() => {
                        table?.setData(res.data?.rows || [])
                        table?.setLoading(false)
                    })
                }} />}
        </TableContext.Consumer>,
        <CustomUpload key={"vat-upload"}/>,
        <Sync key={"sync-action"}/>
    ],


    fetch: async (tableName, filters = {}, page = {}) => {
        return await visualizeCountryVatRates("ALL" )
    },
    enrichColumns:  (columns) => {
        const col = columns.map(x => {
            if (x.name === "country" && x.title === "Items") {
                const formatter = (row, index, name, type, formatted, value) =>{
                    return <ViewItem key={index} row={row} value={value} formatted={formatted}/>
                }
                return {...x, formatter}
            }
            return x
        });
        return col
    }
}
